













































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from './Icon.vue'
import { EUserPermissions } from '@zunta/configurations'
import Api from '@/api'
import { User } from '@/classes/User'
import { VPopover } from 'v-tooltip'
import Status from '@/components/statuses/Status.vue'

@Component({
  props: {
    paymentMethod: {
      type: Object,
      required: true
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    showPrimary: {
      type: Boolean,
      default: true
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Status,
    Icon,
    VPopover
  }
})
export default class CreditCard extends Vue {
  EUserPermissions: any = EUserPermissions
  user: User = Api.getUser() as User
  popoverOpen: boolean = false

  get cardType () {
    if (/^3/.test(this.$props.paymentMethod.first6Digits)) {
      return 'amex'
    }

    if (/^4/.test(this.$props.paymentMethod.first6Digits)) {
      return 'visa'
    }

    if (/^5/.test(this.$props.paymentMethod.first6Digits)) {
      return 'mastercard'
    }

    if (/^6/.test(this.$props.paymentMethod.first6Digits)) {
      return 'discover'
    }

    return ''
  }
}
